.heroContent {
  display: flex;
  flex-direction: column;
  max-width: 380px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 3vw;
  transform: translateY(-50%);
  padding: 3rem;
  border-radius: 5px;
}

.heroContent div span {
  color: #ff9500;
  font-weight: 400;
  font-size: 18px;
}

.heroTitle {
  font-size: 38px;
  font-weight: 200;
  margin: 0;
  color: #fffdf7;
  letter-spacing: 1.5px;
}

.heroSubtitle {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.6px;
  color: #fffdf7;
  margin: 32px 0;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.heroSubtitle p {
  font-size: 18px;
  line-height: 0.8;
}

.heroSubtitle ol {
  list-style: none;
  padding: 0;
  --height: 1.7rem;
  height: var(--height);
  line-height: var(--height);
  overflow: hidden;
}

.heroSubtitle ol li {
  animation: slide-up 8s infinite;
}

.heroSubtitle ol li span {
  white-space: nowrap;
}

@media (max-width: 1024px) {
  .heroContent {
    left: 10vw;
    max-width: 450px;
    padding: 2.8rem;
  }
}

@media (max-width: 768px) {
  .heroContent {
    position: absolute;
    top: 50%;
    left: 48%;
    transform: translate(-50%, -50%);
    width: 70%;
    max-width: 450px;
    color: white;
    border-radius: 10px;
  }

  .heroSubtitle p {
    font-size: 18px;
    line-height: 0.5;
  }
}

@media (max-width: 480px) {
  .heroContent {
    padding: 2rem;
  }

  .heroTitle {
    font-size: 24px;
  }

  .heroSubtitle {
    margin: 20px 0;
  }

  .heroSubtitle p {
    font-size: 14px;
    line-height: 1.12;
  }
  .heroContent div span {
    font-weight: 400;
    font-size: 16px;
  }
}
